<div>
    <app-external-scrollbar targetSyncScroll="8"
        [targetBaseWidth]="tableHolder8"></app-external-scrollbar>
    <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder8
        syncScroll="8">
        <table nxTable nxSort aria-label="approvalDetailTableDesc" class="enquiry" (sortChange)="sortTable($event, 'approvalDetailCoverNoteHistory')">
            <thead>
                <tr nxTableRow>
                    <th nxHeaderCell nxSortHeaderCell="cnoteNo">
                        e-Cover Note No.
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="cnoteDate">
                        Issued Date
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="agent">
                        Agent Code / <br />Agent Name
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="clientName">
                        Customer Name
                    </th>
                    <th class="std-ta-right" nxHeaderCell nxSortHeaderCell="sumInsured">
                        Sum Insured (RM)
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="referBy">
                        Approve / <br />Decline By
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="referDate">
                        Approve / <br />Decline Date
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="referType">
                        Action
                    </th>
                    <th nxHeaderCell nxSortHeaderCell="referAdminRemarks">
                        Remarks
                    </th>
                </tr>
            </thead>
            <tbody>
              @if(approvalDetailCoverNoteHistory != null && approvalDetailCoverNoteHistory.length !== 0) {
                @for(item of approvalDetailCoverNoteHistory; track item) {
                  <tr nxTableRow>
                      <td nxTableCell>{{ item.cnoteNo }}</td>
                      <td nxTableCell>{{ item.cnoteDate }}</td>
                      <td nxTableCell>{{ item.mkagAgent.agentCode }} / {{ item.mkagAgent.name }}</td>
                      <td nxTableCell>{{ item.clientPartner.clientName }}</td>
                      <td nxTableCell>{{ item.sumInsured }}</td>
                      <td nxTableCell>{{ item.referBy }}</td>
                      <td nxTableCell>{{ item.referDate }}</td>
                      <td nxTableCell>{{ item.referType }}</td>
                      <td nxTableCell>
                          {{ item.referAdminRemarks }}
                      </td>
                  </tr>
                }
              }@else {
                <tr nxTableRow>
                      <td nxTableCell colspan="9" class="std-ta-center">NO DATA</td>
                </tr>
              }
            </tbody>
        </table>
    </div>
</div>